import React, { Component } from 'react'

import { withRouter } from 'react-router-dom'

import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timegridPlugin from '@fullcalendar/timegrid';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import interactionPlugin from '@fullcalendar/interaction';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox'
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea'
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { uniqueId } from "lodash"
import filesize from 'filesize'
import { Chart } from 'primereact/chart';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import GaugeChart from "react-gauge-chart";

import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList'
import AtividadeService from '../../app/service/AtividadeService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import ProcessoService from '../../app/service/ProcessoService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'
import UploadAtividadeService from '../../app/service/UploadAtividadeService'
import GraficoAtividadeService from '../../app/service/GraficoAtividadeService'
import UsuarioService from '../../app/service/UsuarioService'
import StatusAtividadeService from '../../app/service/StatusAtividadeService'
import FaseTarefaService from '../../app/service/FaseTarefaService'
import TituloAtividadeFaseService from '../../app/service/TituloAtividadeFaseService'
import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import AgendaService from '../../app/service/AgendaService'

import NavBar from '../../componentes/Navbar'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './painel.css'

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.atividadeService = new AtividadeService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.processoService = new ProcessoService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.uploadAtividadeService = new UploadAtividadeService();
    this.graficoAtividadeService = new GraficoAtividadeService();
    this.usuarioService = new UsuarioService();
    this.statusAtividadeService = new StatusAtividadeService();
    this.faseTarefaService = new FaseTarefaService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.tituloAtividadeFaseService = new TituloAtividadeFaseService();
    this.agendaService = new AgendaService();
 
    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.acoesHistoricoUsuario = this.acoesHistoricoUsuario.bind(this);
    this.acoesHistorico = this.acoesHistorico.bind(this);
    this.acceptExcluirHistorico = this.acceptExcluirHistorico.bind(this);
    this.onChangeStatusAtividade = this.onChangeStatusAtividade.bind(this);
    this.renderFooterProcesso = this.renderFooterProcesso.bind(this);
    this.acoesProcesso = this.acoesProcesso.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.onMudancaData = this.onMudancaData.bind(this);
    this.acoesAtividadeConsultaCalendario = this.acoesAtividadeConsultaCalendario.bind(this);
    this.acoesAtividadeConsultaCalendarioProcesso = this.acoesAtividadeConsultaCalendarioProcesso.bind(this);
    this.template = this.template.bind(this);
    this.templateKanban = this.templateKanban.bind(this);

    this.state = {
      atividadesAtrasadasResponsavelList: [],
      quantidadeAtividadesAtrasadas: '0',
      atividadesHojeResponsavelList: [],
      quantidadeAtividadesHoje: '0',
      atividadesSeteResponsavelList: [],
      quantidadeAtividadesSete: '0',
      atividadesTrintaResponsavelList: [],
      quantidadeAtividadesTrinta: '0',
      quantidadeTotalResponsavel: '0',

      atividadesAtrasadasInterssadosList: [],
      quantidadeAtrasadosInteressados: '0',
      atividadesHojeInteressadosList: [],
      quantidadeHojeInteressados: '0',
      atividadesSeteInteressadosList: [],
      quantidadeSeteInteressados: '0',
      atividadesTrintaInteressadosList: [],
      quantidadeTrintaInteressados: '0',
      quantidadeTotalInteressados: '0',

      compromissosAtrasadosList: [],
      quantidadeAtrasadadosCompromissos: '0',
      compromissosHojeList: [],
      quantidadeHojeCompromissos: '0',
      compromissosSeteList: [],
      quantidadeSeteCompromissos: '0',
      compromissosTrinta: [],
      quantidadeTrintaCompromissos: '0',
      quantidadeTotalCompromissos: '0',

      pontuacao: '',
      pesquisaAtividade: '',
      exibeOcorrenciasEncontradas: 'none',
      ocorrenciasEncontradas: '',

      openSpinner: false,

      layout: 'grid',
      //Alterar Atividade
      atividade: null,
      codigo: '',
      titulo: '',
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      tipo: '',
      status: null,
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      displayAtividade: false,
      displayProcesso: false,
      displayDescricao: false,
      tipoAtividade: null,
      grupos: [],
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      responsaveis: [],
      responsavel: null,
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      processos: [],
      processo: null,
      bloqueiaGrupo: false,
      optionStatus: null,
      responsaveisLista: [],
      quantidadeResponsaveis: '',
      interessadosLista: [],
      quantidadeInteressados: '',
      detail: '',
      processos: [],
      partes: '',
      favorito: '',
      titleFavorito: '',
      exibirFavorito: '',
      importante: '',
      titleImportante: '',
      exibirImportanteEmpresa: '',
      statusAtividade: [],
      selectStatusAtividade: null,

      campoPesquisaProcesso: '',
      processoPesquisadoVisivel: '',
      processoPesquisado: '',
      
      //Histórico
      historico: [],
      registroHistorico: null,
      displayHistorico: null,
      dsHistorico: '',
      displayHistoricoIncluir: false,
      visibleHistorico: false,
      //Arquivos Anexados
      exibirLinkAnexo: 'none',
      displayArquivosAnexados: false,
      upLoadFiles: [],
      nome: '',
      dsArquivo: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      //Graficos dos painés
      graficoStatus: [],
      graficoStatusData: null,
      //Estatística do usuário
      atividadesCriadasUsuario: '',
      atividadesUltimosTrintaDias: '',
      atividadesUltimosTrintaDiasConcluidas: '',
      atividadesUltimosTrintaDiasConcluidasAtrasadas: '',
      atividadesUltimosTrintaDiasConcluidosNoPrazo: '',
      //Kannban
      kanbanAtivo: [],
      kanbanAtivoLabel: '',
      kanbanAtivoExibir: '',

      kanbanFazendo: [],
      kanbanFazendoLabel: '',
      kanbanFazendoExibir: '',

      kanbanAguardando: [],
      kanbanAguardandoLabel: '',
      kanbanAguardandoExibir: '',

      kanbanCiente: [],
      kanbanCienteLabel: '',
      kanbanCienteExibir: '',

      kanbanConcluido: [],
      kanbanConcluidoLabel: '', 
      kanbanConcluidoExibir: '',

      //Filtros Kanban
      usuariosKanban: [],
      selectUsuariosKanban: [],
      gruposKanban: [],
      selectGruposKanban: [],
      dataKanbanInicial: null,
      dataKanbanFinal: null,
      tabAtivo: 0,
      totalAtivos: '',
      totalFazendo: '',
      totalAguardando: '',
      totalCiente: '',
      paramProcessoPrincipal: '',
      mudancaDataHistorico: [],
      //Fases da Atividade
      fases: [],
      fase: null,
      tituloAtividade: null,
      //Mine Agenda
      agenda: [],
      //Lista de atividades
      atividadesLista: [],
      exibirAtividades: 'none',
      dataFiltroAgenda: '',
    };

    this.options = this.getLightTheme();
    this.lightOptions = {
      aspectRatio: .8,
      plugins: {
          legend: {
              labels: {
                  
              }
          }
      }
    };

    this.horizontalOptions = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      aspectRatio: .8,
      plugins: {
          legend: {
              labels: {
                  color: '#495057'
              }
          }
      },
      scales: {
          x: {
              ticks: {
                  color: '#495057'
              },
              grid: {
                  color: '#ebedef'
              }
          },  
          y: {
              ticks: {
                  color: '#495057'
              },
              grid: {
                  color: '#ebedef'
              }
          }
      }
  };
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let horizontalOptions = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      aspectRatio: .8,
      plugins: {
          legend: {
              labels: {
                  color: '#495057'
              }
          }
      },
      scales: {
          x: {
              ticks: {
                  color: '#495057'
              },
              grid: {
                  color: '#ebedef'
              }
          },
          y: {
              ticks: {
                  color: '#495057'
              },
              grid: {
                  color: '#ebedef'
              }
          }
      }
    };

    return {
        basicOptions,
        horizontalOptions
    }
  }

  onMudancaData(e) {
    let selectedCities = [...this.state.mudancaDataHistorico];

    if (e.checked)
        selectedCities.push(e.value);
    else
        selectedCities.splice(selectedCities.indexOf(e.value), 1);

    this.setState({ mudancaDataHistorico: selectedCities });
  }

  listarFases = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade', life: 4000});
      })
  }

  listarFasesPorTitulo = async (titulo) => {
    await this.tituloAtividadeFaseService.listar(titulo.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade por Título', life: 4000});
      })
  }

  consultarTituloAtividadePorNome = async (nome) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.consultarPorNome(nome, usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tituloAtividade: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Título da Atividade pelo nome', life: 4000});
      })
  }

  listarStatusAtividade = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusAtividade: response.data});
        
        this.setState({kanbanAtivoLabel: response.data[0].status});
        this.setState({kanbanAtivoExibir: response.data[0].exibir});

        this.setState({kanbanAguardandoLabel: response.data[1].status});
        this.setState({kanbanAguardandoExibir: response.data[1].exibir});

        this.setState({kanbanCienteLabel: response.data[3].status});
        this.setState({kanbanCienteExibir: response.data[3].exibir});

        this.setState({kanbanConcluidoLabel: response.data[4].status});
        this.setState({kanbanConcluidoExibir: response.data[4].exibir});

        this.setState({kanbanFazendoLabel: response.data[5].status});
        this.setState({kanbanFazendoExibir: response.data[5].exibir});

      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
  }

  //Kanban
  usuariosKanban = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.perfil.codigo == 1) {
      await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
        .then(response => {
          this.setState({usuariosKanban: response.data});
          this.setState({selectUsuariosKanban: response.data});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Lista de usuários por empresa', detail:`${this.state.detail}`, life: 4000});
        })
    } else {
      await this.usuarioService.listarUsuariosEmpresaFiltrado(usuarioLogado.codigo)
        .then(response => {
          this.setState({usuariosKanban: response.data});
          this.setState({selectUsuariosKanban: response.data});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Lista de usuários por empresa', detail:`${this.state.detail}`, life: 4000});
        })
    }
  }

  gruposKanban = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoTrabalhoService.listarGruposUsuario2(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposKanban: response.data});
        this.setState({selectGruposKanban: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grupos de Trabalho por Usuário', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanban = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    var codigosUsuarios = '';
    if(this.state.selectUsuariosKanban != null) {
      var contador = 0;
      var tamanhoLista = this.state.selectUsuariosKanban.length;
      for(let i = 0; i < this.state.selectUsuariosKanban.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosUsuarios = codigosUsuarios + this.state.selectUsuariosKanban[i].codigo + ",";
        } else {
          codigosUsuarios = codigosUsuarios + this.state.selectUsuariosKanban[i].codigo;
        }

        contador++;
      }
    };

    var codigosGrupos = '';
    if(this.state.selectGruposKanban != null) {
      var contador = 0;
      var tamanhoLista = this.state.selectGruposKanban.length;
      for(let i = 0; i < this.state.selectGruposKanban.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosGrupos = codigosGrupos + this.state.selectGruposKanban[i].codigo + ",";
        } else {
          codigosGrupos = codigosGrupos + this.state.selectGruposKanban[i].codigo;
        }

        contador++;
      }
    };
 
    //Datas de filtro
    var dataInicial = null;
    var dataFinal = null;
    if(this.state.dataKanbanInicial != null && this.state.dataKanbanFinal != null) {
      //Data inicial
      var dateInicial = this.state.dataKanbanInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataKanbanFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataFinal =  year+"-"+month+"-"+day;
    };

    const filtroAtivo = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 1,
      limite: 100
    };
    await this.consultarKanbanAtivo(filtroAtivo);

    const filtroAguardando = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 2,
      limite: 100
    };
    await this.consultarKanbanAguardando(filtroAguardando);

    const filtroCiente = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 4,
      limite: 100
    };
    await this.consultarKanbanCiente(filtroCiente);

    const filtroConcluido = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 5,
      limite: 100
    };
    await this.consultarKanbanConcluido(filtroConcluido);

    const filtroFasendo = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: codigosUsuarios,
      grupo: codigosGrupos,
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      status: 6,
      limite: 100
    };
    await this.consultarKanbanFazendo(filtroFasendo);

  }

  consultarKanbanAtivo = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanAtivo: response.data});
        this.setState({totalAtivos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Ativo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanAguardando = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanAguardando: response.data});
        this.setState({totalAguardando: response.data.length});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Aguardando', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanCiente = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanCiente: response.data});
        this.setState({totalCiente: response.data.length});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Ciente', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanConcluido = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanConcluido: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Concluido', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarKanbanFazendo = (filtro) => {
    this.atividadeService.consultarKanban(filtro)
      .then(response => {
        this.setState({kanbanFazendo: response.data});
        this.setState({totalFazendo: response.data.length})
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Painel Kanban Fazendo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  graficoAtividadeUsuario = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.graficoAtividadeService.graficoAtividadeStatusUsuarioPainel(usuarioLogado.codigo)
      .then(response => {
        this.setState({graficoStatus: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Grafico Atividade Usuário', detail:`${this.state.detail}`, life: 4000});
      });

      let status = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        status.push(this.state.graficoStatus[i].status);
      }

      let totais = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        totais.push(this.state.graficoStatus[i].total);
      }

      await this.setState({graficoStatusData: {
        labels: status,
        datasets: [
          {
            data: totais,
            label: '',
            backgroundColor: '#fff',
            backgroundColor: [
              "#b8860b",
              "#b4b4aae3",
              "#00ffff",
              "#1229ab"
            ],
          }
        ]
      }});
  }

  atividadesAtrasadasResponsavel = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.atividadesAtrasadasResponsavel(usuarioLogado.codigo,this.state.pesquisaAtividade)
      .then(response => {
        this.setState({atividadesAtrasadasResponsavelList: response.data})
        this.setState({quantidadeAtividadesAtrasadas: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesHojeResponsavel = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.atividadesHojeResponsavel(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({atividadesHojeResponsavelList: response.data});
        this.setState({quantidadeAtividadesHoje: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesSeteResponsavel = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.atividadesSeteResponsavel(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({atividadesSeteResponsavelList: response.data});
        this.setState({quantidadeAtividadesSete: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesTrintaResponsavel = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.atividadesTrintaResponsavel(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({atividadesTrintaResponsavelList: response.data});
        this.setState({quantidadeAtividadesTrinta: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesAtrasadasInteressados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.atividadesAtrasadasInteressados(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({atividadesAtrasadasInteressadosList: response.data});
        this.setState({quantidadeAtrasadosInteressados: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesHojeInteressados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.atividadesHojeInteressados(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({atividadesHojeInteressadosList: response.data});
        this.setState({quantidadeHojeInteressados: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesSeteInteressados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.atividadesSeteInteressados(usuarioLogado.codigo,this.state.pesquisaAtividade)
      .then(response => {
        this.setState({atividadesSeteInteressadosList: response.data});
        this.setState({quantidadeSeteInteressados: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  atividadesTrintaInteressados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.atividadesTrintaInteressados(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({atividadesTrintaInteressadosList: response.data});
        this.setState({quantidadeTrintaInteressados: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  compromissosAtrasados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.compromissosAtrasados(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({compromissosAtrasadosList: response.data});
        this.setState({quantidadeAtrasadosCompromissos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  compromissosHoje = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.compromissosHoje(usuarioLogado.codigo,this.state.pesquisaAtividade)
      .then(response => {
        this.setState({compromissosHojeList: response.data});
        console.log('A quantidade de compromissos', response.data.length);
        this.setState({quantidadeHojeCompromissos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  compromissosSete = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.compromissosSete(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({compromissosSeteList: response.data});
        this.setState({quantidadeSeteCompromissos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  compromissosTrinta = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.compromissosTrinta(usuarioLogado.codigo, this.state.pesquisaAtividade)
      .then(response => {
        this.setState({compromissosTrintaList: response.data});
        this.setState({quantidadeTrintaCompromissos: response.data.length});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  ativarKanban = async () => {
    this.setState({openSpinner: true});
    this.usuariosKanban();
    this.gruposKanban();
    this.consultarKanban();
    this.setState({openSpinner: false});
  }

  listarAgenda = async () => {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    var contador = 0;
    var tamanhoLista = this.state.gruposKanban.length;
    let codigoGrupos = '';
    for(let i = 0; i < this.state.gruposKanban.length; i++) {
      if(contador < tamanhoLista -1) {
        codigoGrupos = codigoGrupos + this.state.gruposKanban[i].codigo + ",";
      } else {
        codigoGrupos = codigoGrupos + this.state.gruposKanban[i].codigo;
      }

      contador++;
    }

    contador = 0;
    tamanhoLista = this.state.usuariosKanban.length;
    let codigosUsuarios = 0;
    if(usuarioLogado.perfil.codigo != 1) {
      codigosUsuarios = usuarioLogado.codigo;
    } else {
      for(let i = 0; i < this.state.usuariosKanban.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosUsuarios = codigosUsuarios + this.state.usuariosKanban[i].codigo + ",";
        } else {
          codigosUsuarios = codigosUsuarios + this.state.usuariosKanban[i].codigo;
        }

        contador++;
      }
    }

    contador = 0;
    tamanhoLista = this.state.statusAtividade.length;
    let codigosStatus = 0;
    for(let i = 0; i < this.state.statusAtividade.length; i++) {
      if(contador < tamanhoLista -1) {
        codigosStatus = codigosStatus + this.state.statusAtividade[i].codigo + ",";
      } else {
        codigosStatus = codigosStatus + this.state.statusAtividade[i].codigo;
      }

      contador++;
    }

    contador = 0;
    const tipos = [
      {codigo: 'A', nome: 'Compromissos/Audiências'},
      {codigo: 'T', nome: 'Prazos'}
    ];
    tamanhoLista = tipos.length;
    let codigoTipos = '';
    for(let i = 0; i < tipos.length; i++) {
      if(contador < tamanhoLista -1) {
        codigoTipos = codigoTipos + "'" + tipos[i].codigo + "',";
      } else {
        codigoTipos = codigoTipos + "'" + tipos[i].codigo + "'";
      }

      contador++;
    }

    const filtro = {
      usuario: usuarioLogado.codigo,
      usuarios: codigosUsuarios,
      grupos: codigoGrupos,
      status: codigosStatus,
      tipos: codigoTipos
    }
    await this.agendaService.consultarAgendaHomeResumo(filtro)
      .then(response => {
        this.setState({agenda: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  exibirAtividades = async (rowData) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.atividadeService.listarAtividadesPorDataLimite(usuarioLogado.codigo,rowData.event.extendedProps.img)
      .then(response => {
        this.setState({atividadesLista: response.data});
        this.setState({dataFiltroAgendaConsulta: rowData.event.extendedProps.img});
        this.setState({exibirAtividades: 'block'});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      });
      for(let i = 0; i < this.state.atividadesLista.length; i++) {
        this.setState({dataFiltroAgenda: this.state.atividadesLista[i].dtLimite});
        break;
      }
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    this.setState({pesquisaAtividade: ''});
    this.listarStatusAtividade();
    await this.atividadesAtrasadasResponsavel();
    await this.atividadesHojeResponsavel();
    await this.atividadesSeteResponsavel();
    await this.atividadesTrintaResponsavel();
    this.atividadesAtrasadasInteressados();
    this.atividadesHojeInteressados();
    this.atividadesSeteInteressados();
    this.atividadesTrintaInteressados();
    this.compromissosAtrasados();
    this.compromissosHoje();
    this.compromissosSete();
    this.compromissosTrinta();
    this.graficoAtividadeUsuario();
    this.consultaAtividadesCriadasUsuario();
    this.consultaAtividadesUltimosTrintaDiasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasAtrasadasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasNoPrazoUsuario();
    this.consultaPontuacao();

    await this.usuariosKanban();
    await this.gruposKanban();
    this.consultarKanban();
    await this.listarAgenda();

    this.setState({quantidadeTotalResponsavel: parseInt(this.state.quantidadeAtividadesAtrasadas) + 
              parseInt(this.state.quantidadeAtividadesHoje) + parseInt(this.state.quantidadeAtividadesSete) + 
              parseInt(this.state.quantidadeAtividadesTrinta)});
    
    this.setState({quantidadeTotalInteressados: parseInt(this.state.quantidadeAtrasadosInteressados) + 
              parseInt(this.state.quantidadeHojeInteressados) + parseInt(this.state.quantidadeSeteInteressados) + 
              parseInt(this.state.quantidadeTrintaInteressados)});

    this.setState({quantidadeTotalCompromissos: parseInt(this.state.quantidadeAtrasadosCompromissos) + 
                  parseInt(this.state.quantidadeHojeCompromissos) + parseInt(this.state.quantidadeSeteCompromissos) + 
                parseInt(this.state.quantidadeTrintaCompromissos)});

    this.setState({openSpinner: false});
    
  }

  async consultarPaineis() {
    this.setState({openSpinner: true});
    await this.atividadesAtrasadasResponsavel();
    await this.atividadesHojeResponsavel();
    await this.atividadesSeteResponsavel();
    await this.atividadesTrintaResponsavel();
    await this.atividadesAtrasadasInteressados();
    await this.atividadesHojeInteressados();
    await this.atividadesSeteInteressados();
    await this.atividadesTrintaInteressados();
    await this.compromissosAtrasados();
    await this.compromissosHoje();
    await this.compromissosSete();
    await this.compromissosTrinta();
    await this.consultaAtividadesCriadasUsuario();
    await this.consultaAtividadesUltimosTrintaDiasUsuario();
    await this.consultaAtividadesUltimosTrintaDiasConcluidasUsuario();
    await this.consultaAtividadesUltimosTrintaDiasConcluidasAtrasadasUsuario();
    await this.consultaAtividadesUltimosTrintaDiasConcluidasNoPrazoUsuario();
    await this.consultarKanban();
    await this.listarAgenda();

    this.setState({quantidadeTotalResponsavel: parseInt(this.state.quantidadeAtividadesAtrasadas) + 
          parseInt(this.state.quantidadeAtividadesHoje) + parseInt(this.state.quantidadeAtividadesSete) + 
          parseInt(this.state.quantidadeAtividadesTrinta)});
    
    this.setState({quantidadeTotalInteressados: parseInt(this.state.quantidadeAtrasadosInteressados) + 
            parseInt(this.state.quantidadeHojeInteressados) + parseInt(this.state.quantidadeSeteInteressados) + 
            parseInt(this.state.quantidadeTrintaInteressados)});

    this.setState({quantidadeTotalCompromissos: parseInt(this.state.quantidadeAtrasadosCompromissos) + 
                parseInt(this.state.quantidadeHojeCompromissos) + parseInt(this.state.quantidadeSeteCompromissos) + 
              parseInt(this.state.quantidadeTrintaCompromissos)});
    
    if(this.state.pesquisaAtividade == '') {
      this.setState({exibeOcorrenciasEncontradas: 'none'});
    } else {
      this.setState({exibeOcorrenciasEncontradas: 'block'})
      this.setState({ocorrenciasEncontradas: parseInt(this.state.quantidadeAtividadesAtrasadas) + 
        parseInt(this.state.quantidadeAtividadesHoje) + parseInt(this.state.quantidadeAtividadesSete) + 
        parseInt(this.state.quantidadeAtividadesTrinta) +
        parseInt(this.state.quantidadeAtrasadosInteressados) + 
        parseInt(this.state.quantidadeHojeInteressados) + parseInt(this.state.quantidadeSeteInteressados) + 
        parseInt(this.state.quantidadeTrintaInteressados) +  parseInt(this.state.quantidadeAtrasadosCompromissos) + 
        parseInt(this.state.quantidadeHojeCompromissos) + parseInt(this.state.quantidadeSeteCompromissos) + 
      parseInt(this.state.quantidadeTrintaCompromissos) + ' Ocorrência(s) filtrada(s)'});
    }

    this.setState({openSpinner: false});
    //this.refreshPage();
  }

  async consultarPaineisAlteracao() {
    this.setState({openSpinner: true});
    this.setState({tabAtivo: 1});
    this.atividadesAtrasadasResponsavel();
    this.atividadesHojeResponsavel();
    this.atividadesSeteResponsavel();
    this.atividadesTrintaResponsavel();
    this.atividadesAtrasadasInteressados();
    this.atividadesHojeInteressados();
    this.atividadesSeteInteressados();
    this.atividadesTrintaInteressados();
    this.compromissosAtrasados();
    this.compromissosHoje();
    this.compromissosSete();
    this.compromissosTrinta();
    this.graficoAtividadeUsuario();
    this.consultaAtividadesCriadasUsuario();
    this.consultaAtividadesUltimosTrintaDiasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasAtrasadasUsuario();
    this.consultaAtividadesUltimosTrintaDiasConcluidasNoPrazoUsuario();
    this.consultarKanban();

    this.setState({quantidadeTotalResponsavel: parseInt(this.state.quantidadeAtividadesAtrasadas) + 
          parseInt(this.state.quantidadeAtividadesHoje) + parseInt(this.state.quantidadeAtividadesSete) + 
          parseInt(this.state.quantidadeAtividadesTrinta)});
    
    this.setState({quantidadeTotalInteressados: parseInt(this.state.quantidadeAtrasadosInteressados) + 
            parseInt(this.state.quantidadeHojeInteressados) + parseInt(this.state.quantidadeSeteInteressados) + 
            parseInt(this.state.quantidadeTrintaInteressados)});

    this.setState({quantidadeTotalCompromissos: parseInt(this.state.quantidadeAtrasadosCompromissos) + 
                parseInt(this.state.quantidadeHojeCompromissos) + parseInt(this.state.quantidadeSeteCompromissos) + 
              parseInt(this.state.quantidadeTrintaCompromissos)});

    this.setState({openSpinner: false});
    //this.refreshPage();
  }

  atualizarPaineis = () => {
    this.atividadesAtrasadasResponsavel();
    this.atividadesHojeResponsavel();
  }

  async consultarAtividade(atividade) {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.atividadeService.consultarAtividade(atividade.codigoAtividade)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({descricao: response.data.descricao});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({tipo: response.data.tipo});
        this.consultarGruposTrabalho();
        this.setState({selectSubGrupo: response.data.subGrupo});
        this.setState({fase: response.data.fase});
        if(response.data.processo != null) {
          this.setState({partes: atividade.partes});
          if(atividade.favorito != null && atividade.favorito != 'N') {
            this.setState({favorito: 'p-button-rounded p-button-danger'});
            this.setState({titleFavorito: 'Processo classificado como meus favoritos'});
            this.setState({exibirFavorito: 'hide'});
          } else {
            this.setState({favorito: 'p-button-rounded p-button-secondary'});
            this.setState({titleFavorito: 'Este processo não está classificado como meus favoritos'});
            this.setState({exibirFavorito: 'none'});
          }
          if(atividade.importante != null && atividade.importante != 'N') {
            this.setState({importante: 'p-button-rounded p-button-warning'});
            this.setState({titileImportante: 'Processo importante para empresa'});
            this.setState({exibirImportanteEmpresa: 'hide'});
          } else {
            this.setState({importante: 'p-button-rounded p-button-secondary'});
            this.setState({titileImportante: 'Processo normal'});
            this.setState({exibirImportanteEmpresa: 'none'});
          }
          this.setState({processo: response.data.processo});
          this.setState({processoPesquisado: response.data.processo.nrProcesso});
          this.setState({processoPesquisadoVisivel: 'block'});
          this.setState({sizePesquisa: 'col-sm-5'});
          this.setState({campoPesquisaProcesso: 'none'});
          console.log('Tamanho do numero do processo', response.data.processo.nrProcesso.length);
          if(response.data.processo.nrProcesso != null && response.data.processo.nrProcesso != '' && response.data.processo.nrProcesso.length -1 == 20) {
            var cnjMascarado = response.data.processo.nrProcesso.substring(0, 7);
                cnjMascarado = cnjMascarado + "-" + response.data.processo.nrProcesso.substring(7, 9);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrProcesso.substring(9, 13);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrProcesso.substring(13, 14);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrProcesso.substring(14, 16);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrProcesso.substring(16, 20);
                console.log('Derrota', cnjMascarado)
            this.setState({processoPesquisado: cnjMascarado});
          } else {
            this.setState({processoPesquisado: response.data.processo.nrProcesso});
          }
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'block'
          }});
          this.setState({bloqueiaGrupo: true});
        } else {
          this.setState({processo: null});
          this.setState({sizePesquisa: 'col-sm-12'});
          this.setState({bloqueiaGrupo: false});
          this.setState({processoPesquisado: ''});
          this.setState({processoPesquisadoVisivel: 'none'});
          this.setState({campoPesquisaProcesso: 'block'})
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'none'
          }});
          this.setState({pesquisaProcesso: ''});
        }
        var dataLimite = new Date(response.data.dtLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
        
        this.setState({status: response.data.status})
      }
    ).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    });
    await this.listarArquivosAtividade();
    await this.consultarResponsaveis();
    await this.consultarInteressados();   
    await this.consultarGruposTrabalho(); 
    if(usuarioLogado.empresa.tituloPredefinido == 'N') {
      await this.listarFases();
    } else {
      await this.consultarTituloAtividadePorNome(this.state.titulo, usuarioLogado.empresa.codigo);
      await this.listarFasesPorTitulo(this.state.tituloAtividade);
    }
    this.abrirModalAtividadeAlterar('displayAtividade');
    this.setState({openSpinner: false});
  }

  async consultarAtividadeCalendario(atividade) {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.atividadeService.consultarAtividade(atividade.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({descricao: response.data.descricao});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({tipo: response.data.tipo});
        this.consultarGruposTrabalho();
        this.setState({selectSubGrupo: response.data.subGrupo});
        this.setState({fase: response.data.fase});
        if(response.data.processo != null) {
          this.setState({partes: atividade.partes});
          if(atividade.favorito != null && atividade.favorito != 'N') {
            this.setState({favorito: 'p-button-rounded p-button-danger'});
            this.setState({titleFavorito: 'Processo classificado como meus favoritos'});
            this.setState({exibirFavorito: 'hide'});
          } else {
            this.setState({favorito: 'p-button-rounded p-button-secondary'});
            this.setState({titleFavorito: 'Este processo não está classificado como meus favoritos'});
            this.setState({exibirFavorito: 'none'});
          }
          if(atividade.importante != null && atividade.importante != 'N') {
            this.setState({importante: 'p-button-rounded p-button-warning'});
            this.setState({titileImportante: 'Processo importante para empresa'});
            this.setState({exibirImportanteEmpresa: 'hide'});
          } else {
            this.setState({importante: 'p-button-rounded p-button-secondary'});
            this.setState({titileImportante: 'Processo normal'});
            this.setState({exibirImportanteEmpresa: 'none'});
          }
          this.setState({processo: response.data.processo});
          this.setState({processoPesquisado: response.data.processo.nrCnj});
          this.setState({processoPesquisadoVisivel: 'block'});
          this.setState({sizePesquisa: 'col-sm-5'});
          this.setState({campoPesquisaProcesso: 'none'});
          if(response.data.processo.nrCnj != null && response.data.processo.nrCnj != '') {
            var cnjMascarado = response.data.processo.nrCnj.substring(0, 7);
                cnjMascarado = cnjMascarado + "-" + response.data.processo.nrCnj.substring(7, 9);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(9, 13);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(13, 14);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(14, 16);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(16, 20);
            this.setState({processoPesquisado: cnjMascarado});
          } else {
            this.setState({processoPesquisado: response.data.processo.nrProcesso});
          }
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'block'
          }});
          this.setState({bloqueiaGrupo: true});
        } else {
          this.setState({processo: null});
          this.setState({sizePesquisa: 'col-sm-12'});
          this.setState({bloqueiaGrupo: false});
          this.setState({processoPesquisado: ''});
          this.setState({processoPesquisadoVisivel: 'none'});
          this.setState({campoPesquisaProcesso: 'block'})
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'none'
          }});
          this.setState({pesquisaProcesso: ''});
        }
        var dataLimite = new Date(response.data.dtLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
        
        this.setState({status: response.data.status})
      }
    ).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    });
    await this.listarArquivosAtividade();
    await this.consultarResponsaveis();
    await this.consultarInteressados();   
    await this.consultarGruposTrabalho(); 
    if(usuarioLogado.empresa.tituloPredefinido == 'N') {
      await this.listarFases();
    } else {
      await this.consultarTituloAtividadePorNome(this.state.titulo, usuarioLogado.empresa.codigo);
      await this.listarFasesPorTitulo(this.state.tituloAtividade);
    }
    this.abrirModalAtividadeAlterar('displayAtividade');
    this.setState({openSpinner: false});
  }

  listarArquivosAtividade = async () => {
    await this.arquivoAtividadeService.listarArquivos(this.state.atividade.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
        if(response.data.length > 0) {
          this.setState({exibirLinkAnexo: 'block'});
        } else {
          this.setState({exibirLinkAnexo: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async abrirModalArquivosAnexos(name, position){
    await this.listarArquivosAtividade()
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  async onGrupoTrabalhoChange(e) {
    await this.setState({selectGrupo: e.value});
    this.consultarSubGrupos(this.state.selectGrupo.codigo);
    await this.setState({responsaveisLista: null});
    await this.setState({interessadosLista: null});
    this.listarResponsaveis();
    this.listarInteressados();
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  onChangeStatusAtividade(e) {
    this.setState({status: e.value})
  }

  consultarProcessoPorIndice = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    const indice = {
      indice: this.state.pesquisaProcesso,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }

    await this.processoService.consultarProcessoPorIndice(indice)
      .then(response => {
        this.setState({processos: response.data});
        if(response.data.length > 0) {
          this.abrirModalProcesso('displayProcesso');
        } else {
          this.setState({pesquisaProcesso: ''});
          this.toast.show({severity:'error', summary: 'Processo', detail:'Processo não encontrado', life: 4000});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }

  excluirPesquisaProcesso = async () => {
    this.setState({processo: null});
    this.setState({pesquisaProcesso: ''});
    this.setState({processoPesquisado: ''});
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({campoPesquisaProcesso: 'block'});
    this.setState({bloqueiaGrupo: false});
    this.setState({selectGrupo: null});
    this.setState({subGrupos: null});
    this.setState({selectSubGrupo: null});
    this.setState({responsaveisLista: []});
    this.setState({interessadosLista: []});
    this.setState({responsaveis: ''});
  }

  abrirModalProcesso(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  acoesProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-check" className="p-button-rounded p-button-text" 
                tooltip="Editar"
                onClick={() => this.selecionarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  renderFooterProcesso(name) {
    return (
        <div className="left">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  async selecionarProcesso(processo) {
    await this.processoService.consultarProcessoPorCodigo(processo.codigo)
      .then(response => {
        this.setState({processo: response.data});
        this.setState({pesquisaProcesso: processo.nrCnj});
        this.setState({selectGrupo: response.data.grupoTrabalho})
        this.setState({bloqueiaGrupo: true});
        this.setState({campoPesquisaProcesso: 'none'});
        this.setState({processoPesquisadoVisivel: 'block'});
        this.setState({sizePesquisa: 'col-sm-5'});
        this.setState({escondeBotalExcluirPesquisa: {
          display: 'block'
        }});

        if(response.data.nrCnj != '') {
          var cnjMascarado = response.data.nrCnj.substring(0, 7);
              cnjMascarado = cnjMascarado + "-" + response.data.nrCnj.substring(7, 9);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(9, 13);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(13, 14);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(14, 16);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(16, 20);
          this.setState({processoPesquisado: cnjMascarado});
        } else {
          this.setState({processoPesquisado: response.data.nrProcesso});
        }

        this.consultarSubGrupos(this.state.selectGrupo.codigo);
        this.listarResponsaveis();
        this.listarInteressados();
        this.fecharModalAtividade('displayProcesso');
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  alterarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.titulo == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsaveisLista == null || this.state.responsaveisLista.size == 0) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    let tipoTarefa = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '' && this.state.hora != null) {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
        tipoTarefa = 'A';
      } else {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = "";
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != null && this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.titulo,
        tipo: tipoTarefa,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        processo: this.state.processo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.status,
        subGrupo: this.state.selectSubGrupo,
        fase: this.state.fase
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    var hora = "00:00";
    if(this.state.hora != null) {
      hora = this.state.hora;
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarAtividade(this.state.atividade.dtLimite + " " + hora + ":00",
      this.state.atividade.status.codigo, usuarioLogado.codigo,atividadeAlterar
      ).then(response => {
        this.consultarPaineisAlteracao();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
        this.fecharModalAtividade('displayAtividade');
      }).catch(error => {
        this.setState(error.response.data);
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 8000});
      });
      this.setState({openSpinner: false});
  }

  refreshPage = () => {
    window.location.reload();
  }

  consultarResponsaveis = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'R')
      .then(response => {
        this.setState({responsaveisLista: response.data});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.listarResponsaveis(); 
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarInteressados = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'I')
      .then(response => {
        this.setState({interessadosLista: response.data});
        if(this.state.interessadosLista.length == 0) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.listarInteressados();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
        this.abrirModalHistorico('displayHistorico');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesHistoricoUsuario(rowData) {
      if(rowData.tpHistorico == 'A') {
        return (
          <React.Fragment>
            <i className="fa fa-solid fa-robot" title="Incluído de forma automática"/>
          </React.Fragment>
        )
      } else {
        return (
          <React.Fragment>
            <i className="pi pi-user-plus" title="Incluído manualmente"/>
          </React.Fragment>
        )
      }
  }

  acoesHistorico(rowData) {
    if(rowData.tpHistorico != 'A') {
      return (
        <React.Fragment>
           <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                   tooltip="Excluir Histórico"
                   onClick={() => this.confirmaExclusaoHistorico(rowData)}
                   tooltipOptions={{position: 'top'}}
                   style={{width: '20px', height: '10px'}}/>
        </React.Fragment>
      )
    } 
  }

  consultarGrupoTrabalhoPai = async (codigo) => {
    await this.grupoTrabalhoService.consultarGrupo(codigo)
      .then(response => {
        this.setState({selectGrupo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Grupo de Trabalho', life: 4000});
      })
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Alterar" 
                    onClick={this.alterarAtividade}
                    className="p-button-primary p-button-text"/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexados')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Histórico" 
                    icon="pi pi-history"
                    className="p-button-help p-button-text"
                    onClick={this.consultarHistorico}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalAtividadeAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModalDescricao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModalHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  novoHistorico = () => {
    this.setState({dsHistorico: ''});
    this.abrirModalHistorico('displayHistoricoIncluir');
  }

  async incluirHistorico () {
    const usuarioLogado = this.context.usuarioAutenticado
    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    let tipoHistorico = 'M';
    if(usuarioLogado.empresa.codigo == 138) {
      let data = 'N';
        if(this.state.mudancaDataHistorico != null & this.state.mudancaDataHistorico.length > 0) {
          for(let i = 0; i < this.state.mudancaDataHistorico.length; i++) {
            if(this.state.mudancaDataHistorico[i] == 'mudancaData') {
              data = 'S'
            }
          }
        }

        if(data == 'S') {
          tipoHistorico = 'D';
        } else {
          tipoHistorico = 'M';
        }
    } else {
      tipoHistorico = 'M';
    }

    await this.atividadeService.incluirHistorico({
      atividade: this.state.atividade,
      dsHistorico: this.state.dsHistorico,
      usuario: usuarioLogado,
      tpHistorico: tipoHistorico
    }).then(response => {
      this.listarHistorico();
      this.fecharModalAtividade('displayHistoricoIncluir');
      this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico incluído com sucesso', life: 4000});
    });
  }

  listarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  confirmaExclusaoHistorico(historico) {
    this.setState({registroHistorico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir o Histórico da Atividade?',
        header: 'Exclusão de Histórico de Atividades',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistorico,
        reject: this.reject
    });
  }

  acceptExcluirHistorico() {
    this.excluirHistorico();
  }

  excluirHistorico = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.excluirHistorico(this.state.registroHistorico.codigo, this.state.registroHistorico.usuario.codigo, usuarioLogado.codigo)
      .then(response => {
        this.listarHistorico();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico excluído', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  consultarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      })
  }

  consultarSubGrupos = async(codigo) => {
    await this.grupoTrabalhoService.listarSubGrupos(codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  Processo(data,status) {
    return (
        <div className="card">
          <div className="col-12">
            <div>
                <div>
                    <div style={{paddingTop: '5px', paddingBottom: '5px'}} className={status}>{data.statusCalculado}</div>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividade(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtFatal}</strong>
                    </div>
                    <div className="product-name"><a className="cursor" onClick={() => this.editarProcesso(data)}>{data.processo.nrCnj}</a></div>
                    <div className="grupoTrabalho">{data.processo.grupoTrabalho.nome}</div>
                    <div style={{paddingBottom: '5px', paddingTop: '5px'}}>{data.processo.autor}</div>
              </div>
            </div>
          </div>
        </div>
    );
  }

  editarProcesso(atividade) {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${atividade.codigoProcesso}/SEARCH`});
  }

  editarProcessoConsultaAgenda(atividade) {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${atividade.processo.codigo}/SEARCH`});
  }

  editarProcessoNaAtividade = () => {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${this.state.atividade.processo.codigo}/SEARCH`});
    //this.props.history.push(`/fichaProcesso/${atividade.codigoProcesso}`);
  }

  templateSemProcesso(data, status) {
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <br/>
                    <div style={{paddingTop: '2px', paddingBottom: '2px'}} className={status}>{data.descricaoStatus} - ({data.snFinanceiro})
                    </div>
                    <div className="grupoTrabalho">{data.fase}</div>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividade(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtfatal}</strong>
                    </div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }

  templateSemProcessoKanban(data) {
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <br/>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividade(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtfatal}</strong>
                    </div>
                    <div className="grupoTrabalho">{data.fase}</div>
                    <div className="usuario">
                      {data.responsaveis}
                    </div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }

  templateProcesso(data,status) {
    var favorito = '';
    var titleFavorito = '';
    var exibirFavorito = '';
    var importante = '';
    var titileImportante = '';
    var exibirImportanteEmpresa = '';
    if(data.favorito != null && data.favorito != 'N') {
      favorito = 'p-button-rounded p-button-danger';
      titleFavorito = 'Este processo está classificado como meus favoritos';
      exibirFavorito = 'hide';
    } else {
      favorito = 'p-button-rounded p-button-secondary';
      titleFavorito = 'Este processo não está classificado como meus favoritos';
      exibirFavorito = 'none';
    }

    if(data.importante != null && data.importante != 'N') {
      importante = 'p-button-rounded p-button-warning';
      titileImportante = 'Processo classificado como importante para empresa';
      exibirImportanteEmpresa = 'hide';
    } else {
      importante = 'p-button-rounded p-button-secondary';
      titileImportante = 'Processo normal';
      exibirImportanteEmpresa = 'none';
    }
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <br/>
                    <div style={{paddingTop: '2px', paddingBottom: '2px'}} className={status}>{data.descricaoStatus} - ({data.snFinanceiro})
                    </div>
                    <div className="grupoTrabalho">{data.fase}</div>
                    <br/>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividade(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtfatal}</strong>
                    </div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    
                    <div className="product-name" style={{textAlign: 'left'}}><a className="cursor" 
                                                    href={this.state.paramProcessoPrincipal}
                                                    target="_blank"
                                                    onClick={() => this.editarProcesso(data)}>{data.nrprocesso}</a></div>
                  
                    <div style={{paddingBottom: '5px', paddingTop: '5px'}}>{data.partes}</div>
                    <div style={{textAlign: 'left'}}>
                      <Button icon="pi pi-star"
                              className={favorito} 
                              tooltip={titleFavorito} 
                              tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                              style={{width: '20px', height: '10px', display: `${exibirFavorito}`}}/>
                      &nbsp;
                      <Button icon="pi pi-heart" 
                              className={importante}
                              tooltip={titileImportante} 
                              tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                              style={{width: '20px', height: '10px', display: `${exibirImportanteEmpresa}`}} />
                    </div>
                </div>
            </div>
          </div>
        </div>
    );
  }

  templateProcessoKanban(data) {
    var favorito = '';
    var titleFavorito = '';
    var exibirFavorito = '';
    var importante = '';
    var titileImportante = '';
    var exibirImportanteEmpresa = '';
    if(data.favorito != null && data.favorito != 'N') {
      favorito = 'p-button-rounded p-button-danger';
      titleFavorito = 'Este processo está classificado como meus favoritos';
      exibirFavorito = 'hide';
    } else {
      favorito = 'p-button-rounded p-button-secondary';
      titleFavorito = 'Este processo não está classificado como meus favoritos';
      exibirFavorito = 'none';
    }

    if(data.importante != null && data.importante != 'N') {
      importante = 'p-button-rounded p-button-warning';
      titileImportante = 'Processo classificado como importante para empresa';
      exibirImportanteEmpresa = 'hide';
    } else {
      importante = 'p-button-rounded p-button-secondary';
      titileImportante = 'Processo normal';
      exibirImportanteEmpresa = 'none';
    }

    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <br/>
                    <div className="titulo">
                        <a onClick={() => this.consultarAtividade(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtLimite}&nbsp;&nbsp;
                        <strong className="dataFatal">{data.dtfatal}</strong>
                    </div>
                    <div className="grupoTrabalho">{data.fase}</div>
                    <div className="usuario">
                      {data.responsaveis}
                    </div>
                    <div className="product-name"><a className="cursor" 
                                                     href={this.state.paramProcessoPrincipal}
                                                     target="_blank"
                                                     onClick={() => this.editarProcesso(data)}>{data.nrprocesso}</a></div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    <div style={{paddingBottom: '5px', paddingTop: '5px'}}>{data.partes}</div>
                    <div style={{textAlign: 'left'}}>
                      <Button icon="pi pi-star"
                              className={favorito} 
                              tooltip={titleFavorito} 
                              tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                              style={{width: '20px', height: '10px', display: `${exibirFavorito}`}}/>
                      &nbsp;
                      <Button icon="pi pi-heart" 
                              className={importante}
                              tooltip={titileImportante} 
                              tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                              style={{width: '20px', height: '10px', display: `${exibirImportanteEmpresa}`}} />
                    </div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }
  
  templateProcessoKanbanConcluido(data) {
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <div className="titulo">
                        <br/>
                        <a onClick={() => this.consultarAtividade(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtConcluido}
                    </div>
                    <div className="usuario">
                      {data.responsaveis}
                    </div>
                    <div className="product-name"><a className="cursor" onClick={() => this.editarProcesso(data)}>{data.nrprocesso}</a></div>
                    <div className="grupoTrabalho">{data.grupo} - &nbsp;{data.subGrupo}</div>
                    <div style={{paddingBottom: '5px', paddingTop: '5px'}}>{data.partes}</div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }

  templateSemProcessoKanbanConcluido(data) {
    return (
        <div className="card" style={{borderRadius: '6px'}}>
          <div className="col-12">
            <div>
                <div>
                    <div className="titulo">
                        <br/>
                        <a onClick={() => this.consultarAtividade(data)} className="cursor">{data.titulo}</a>&nbsp;{data.dtConcluido}
                    </div>
                    <div className="usuario">
                      {data.responsaveis}
                    </div>
                    <div className="grupoTrabalho">{data.subGrupo}&nbsp; - &nbsp;{data.grupo}</div>
                    <br/>
                </div>
            </div>
          </div>
        </div>
    );
  }

  template(data) {
    let status = '';
    switch(data.status) {
      case 50456917:
          status = 'statusAtivo';
          break;
      case 50456918:
          status = 'statusAguardando';
          break;
      case 50456919:
          status = 'statusCancelado'
          break;
      case 50456920:
          status = 'statusCiente';
          break;
      case 50456921:
          status = 'statusConcluído'
          break;
      default:
          status = 'statusFazendo'
          break;
    }
    if(data.codigoProcesso != 0) {
      return this.templateProcesso(data,status);
    } else {
      return this.templateSemProcesso(data,status);
    }
  }

  templateKanban(data) {
    let status = '';
    switch(data.status) {
      case 1:
          status = 'statusAtivo';
          break;
      case 2:
          status = 'statusAguardando';
          break;
      case 3:
          status = 'statusCancelado'
          break;
      case 4:
          status = 'statusCiente';
          break;
      case 5:
          status = 'statusConcluído'
          break;
      default:
          status = 'statusFazendo'
          break;
    }
    if(data.status != 5) {
      if(data.codigoProcesso != 0) {
        return this.templateProcessoKanban(data, status);
      } else {
        return this.templateSemProcessoKanban(data, status);
      }
    } else {
      if(data.codigoProcesso != 0) {
        return this.templateProcessoKanbanConcluido(data, status);
      } else {
        return this.templateSemProcessoKanbanConcluido(data, status);
      }
    }
  }

  templateHistoricoAtividade(data) {
    var icone = '';
    var titulo = '';
    if(data.tpHistorico == 'A') {
      icone = 'fa fa-solid fa-robot';
      titulo = 'Incluído de forma automática';
    } else {
      icone = 'pi pi-user-plus';
      titulo = 'Incluído manualmente';
    }
    return (
      <div className="col-12">
        <div>
          <strong style={{textAlign: 'left', color: 'blue'}}
                  className="grupoTrabalho">
             {data.usuario.nome} - {data.dtHistorico}
          </strong>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong style={{textAlign: 'right'}}>
            <i className={icone} title={titulo}/>
          </strong>
        </div>
        <br />
        <div className="balao" style={{borderRadius: '6px'}}>
          {data.dsHistorico}
        </div>
        <br/>
      </div>
    )
  }

  //Tudo referente a upload de documentos
  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoAtividadeService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  async consultarArquivoDescricao(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  async consultarArquivo(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivo = () => {
    this.arquivoAtividadeService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosAtividade();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>

            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/>
            &nbsp;
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.adicionarDescricao}/> 

      </div>
    );
  }

  adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      dsArquivo: this.state.dsArquivo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosAtividade();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('atividade',upLoadFile.file, this.state.atividade.codigo) //Envia código de atividade para salvar os arquivos
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de atividade para salvar os arquivos
    await this.arquivoAtividadeService.incluirArquivo(data)
      .then(response => {
        this.listarArquivosAtividade();
        this.handleDelete(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  consultaAtividadesCriadasUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.atividadeService.consultaAtividadesCriadasUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesCriadasUsuario: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaAtividadesUltimosTrintaDiasUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.atividadeService.consultaAtividadesUltimosTrintaDias(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesUltimosTrintaDias: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaAtividadesUltimosTrintaDiasConcluidasUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.atividadeService.consultaAtividadesUltimosTrintaDiasConcluidas(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesUltimosTrintaDiasConcluidas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaAtividadesUltimosTrintaDiasConcluidasAtrasadasUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.atividadeService.consultaAtividadesUltimosTrintaDiasConcluidasAtrasadas(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesUltimosTrintaDiasConcluidasAtrasadas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaAtividadesUltimosTrintaDiasConcluidasNoPrazoUsuario = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.atividadeService.consultaAtividadesUltimosTrintaDiasConcluidasNoPrazo(usuarioLogado.codigo)
      .then(response => {
        this.setState({atividadesUltimosTrintaDiasConcluidasNoPrazo: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades Criadas Usuários', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultaPontuacao = () => {
    this.atividadeService.consultaPontuacao(this.state.quantidadeAtividadesHoje,this.state.quantidadeHojeInteressados,this.state.quantidadeHojeCompromissos)
        .then(response => {
          this.setState({pontuacao: response.data});
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Esquema de pontuação', detail:`${this.state.detail}`, life: 4000});
        })
  }

  acoesAtividadeConsultaCalendario(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.consultarAtividadeCalendario(rowData)} style={{cursor: 'pointer', color: 'blue'}}>{rowData.titulo}</a>
      </React.Fragment>
    );
  }
  s
  acoesAtividadeConsultaCalendarioProcesso(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.editarProcessoConsultaAgenda(rowData)}
           href={this.state.paramProcessoPrincipal} 
           style={{cursor: 'pointer', color: 'blue'}}
           target="_blank">{rowData.processo.nrCnj}
        </a>
      </React.Fragment>
    );
  }

  render() {
    const { upLoadFiles } = this.state;
    const { horizontalOptions, basicOptions } = this.options;
    const usuarioLogado = this.context.usuarioAutenticado;
    var exibieDataHistorico = 'none';
    if(usuarioLogado.empresa.codigo == 138) {
      exibieDataHistorico = 'block'
    } else {
      exibieDataHistorico = 'none'
    }

    var bloqueiaTitulo = '';
    if(usuarioLogado.empresa.codigo == 138) {
      bloqueiaTitulo = 'false';
    }

    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        {/**Alterar Atividade */}
        <Dialog header="Atividade" autoComplete="nope"
                visible={this.state.displayAtividade} 
                footer={this.renderFooterAtividade('displayAtividade')} 
                onHide={() => this.fecharModalAtividade('displayAtividade')}>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <InputText id="titulo" 
                              disabled={bloqueiaTitulo}
                              style={{width: '100%', height: '32px'}}
                              type="text" 
                              autoComplete="nope"
                              value={this.state.titulo}
                              onChange={e => this.setState({titulo: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"
                              placeholder="Título"/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <Dropdown value={this.state.fase} style={{width: '100%', height: '32px'}} 
                            options={this.state.fases} style={{width: '100%', height: '32px'}}
                            optionLabel="nome" 
                            emptyMessage=" "
                            filter showClear filterBy="nome"
                            onChange={e => this.setState({fase: e.target.value})}
                            id="faseAtividade"
                            className="p-inputtext-sm p-d-block p-mb-1"
                            placeholder="Fase da Atividade"/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group" style={{display: `${this.state.campoPesquisaProcesso}`}}>
                  <InputText id="processo" style={{width: '100%', height: '32px'}}
                            type="text"
                            autoComplete="nope"
                            value={this.state.pesquisaProcesso}
                            onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
                            onChange={e => this.setState({pesquisaProcesso: e.target.value})}
                            className="p-inputtext-sm p-d-block p-mb-1"
                            placeholder="Incluir Processo, Pesquise o processo por Pessoa, Pasta ou Número"/>
                </div>
                <div className="form-group" style={{display: `${this.state.processoPesquisadoVisivel}`}}>
                  <strong>Processo:&nbsp;&nbsp;
                            <a className="cursor" 
                               href={this.state.paramProcessoPrincipal}
                               target="_blank"
                               onClick={this.editarProcessoNaAtividade}>{this.state.processoPesquisado}</a>
                  <br/>
                  {this.state.partes}
                  <div style={{textAlign: 'left'}}>
                    <Button icon="pi pi-heart"
                            className={this.state.favorito} 
                            tooltip={this.state.titleFavorito} 
                            tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                            style={{width: '20px', height: '10px', display: `${this.state.exibirFavorito}`}}/>
                    &nbsp;
                    <Button icon="pi pi-star" 
                            className={this.state.importante}
                            tooltip={this.state.titileImportante} 
                            tooltipOptions={{ className: 'blue-tooltip', position: 'top' }} 
                            style={{width: '20px', height: '10px', display: `${this.state.exibirImportanteEmpresa}`}} />
                  </div>
                  </strong>
                  <a onClick={this.excluirPesquisaProcesso} className="linkCadGrupo" style={{cursor: 'pointer'}}>Desvincular Processo</a>
                </div>
              </div>
            </div>
            
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <Dropdown value={this.state.selectGrupo} style={{width: '100%', height: '32px'}} 
                            options={this.state.grupos}
                            disabled={this.state.bloqueiaGrupo}
                            optionLabel="nome" 
                            filter showClear filterBy="nome"
                            onChange={this.onGrupoTrabalhoChange}
                            id="grupoTrabalho"
                            className="p-inputtext-sm p-d-block p-mb-1"
                            placeholder="Grupo de Trabalho"/>
                    <a className="linkCadGrupo" href="#">Incluir novo Grupo de Trabalho</a>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                  options={this.state.subGrupos} style={{width: '100%', height: '32px'}}
                  optionLabel="nome" 
                  emptyMessage=" "
                  filter showClear filterBy="nome"
                  onChange={this.onSubGrupoChange}
                  id="subGrupoTrabalho"
                  className="p-inputtext-sm p-d-block p-mb-1"
                  placeholder="Sub-Grupo de Trabalho"/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <MultiSelect inputId="multiselect" 
                                value={this.state.responsaveisLista} 
                                options={this.state.responsaveis} 
                                style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                onChange={(e) => this.setState({ responsaveisLista: e.value })} 
                                filter showClear filterBy="nome"
                                optionLabel="nome" 
                                placeholder="Responsáveis"/>
                  <label className="linkCadGrupo">{this.state.quantidadeResponsaveis}</label>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <MultiSelect inputId="multiselect" 
                                value={this.state.interessadosLista} 
                                options={this.state.responsaveis} 
                                style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                onChange={(e) => this.setState({ interessadosLista: e.value })}  
                                filter showClear filterBy="nome"
                                optionLabel="nome" 
                                placeholder="Interssados"/>
                  <label className="linkCadGrupo">{this.state.quantidadeInteressados}</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <Calendar id="mask" 
                            value={this.state.dtLimite} 
                            onChange={(e) => this.setState({ dtLimite: e.value })} 
                            locale="es"
                            style={{width: '100%', height: '32px'}} 
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            placeholder="Data Limite"/>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                <InputMask id="hora" style={{width: '100%', height: '32px'}}
                            type="text"
                            mask="99:99"
                            value={this.state.hora}
                            onChange={e => this.setState({hora: e.target.value})}
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <Calendar id="mask" 
                            value={this.state.dtFatal} 
                            onChange={(e) => this.setState({ dtFatal: e.value })} 
                            locale="es"
                            style={{width: '100%', height: '32px'}} 
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            placeholder="Prazo fatal"/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <InputTextarea value={this.state.descricao} style={{width: '100%'}}
                                  id="descricaoE"
                                  onChange={e => this.setState({descricao: e.target.value})}
                                  rows={4} 
                                  cols={60} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <Dropdown value={this.state.status} style={{width: '100%', height: '32px'}} 
                            options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                            optionLabel="status" 
                            emptyMessage=" "
                            filter showClear filterBy="status"
                            onChange={this.onChangeStatusAtividade}
                            id="idStatusAtividade"
                            className="p-inputtext-sm p-d-block p-mb-1"/>
                </div>
              </div>
            </div>
        </Dialog>
        {/**Histórico de Atividades */}
        <Dialog header="Histórico da Ativide" autoComplete="nope"
                style={{ height: '50vw', width: '25vw' }} 
                visible={this.state.displayHistorico} 
                footer={
                  <frameElement>
                    <Button label="Incluir" 
                            className="p-button-primary p-button-text"
                            onClick={this.novoHistorico}/>
                    &nbsp;
                    <Button label="Fechar" 
                            className="p-button-secondary p-button-text"
                            onClick={() => this.fecharModalAtividade('displayHistorico')}/>
                  </frameElement>
                  
                } 
                onHide={() => this.fecharModalAtividade('displayHistorico')}>
            <DataView value={this.state.historico}
                      layout={this.state.layout}
                      emptyMessage=" "
                      itemTemplate={this.templateHistoricoAtividade}/>

        </Dialog>
        {/**Confirmação de exclusão de Histórico */}
        <ConfirmDialog visible={this.state.visibleHistorico} 
                       onHide={() => this.setState({ visibleHistorico: false })} 
                       message="Are you sure you want to proceed?"
                       header="Confirmation"
                       icon="pi pi-exclamation-triangle" 
                       accept={() => this.excluirHistorico} 
                       reject={() => this.setState({visibleHistorico: false})}/>
        
        {/**Incluir um novo histórico */}
        <Dialog header="Incluir Histórico" autoComplete="nope"
                style={{ width: '40vw' }} 
                visible={this.state.displayHistoricoIncluir} 
                footer={
                  <frameElement>
                    <Button label="Incluir" 
                            className="p-button-primary p-button-text"
                            onClick={() => this.incluirHistorico()}/>
                    &nbsp;
                    <Button label="Fechar" 
                            className="p-button-secondary p-button-text"
                            onClick={() => this.fecharModalAtividade('displayHistoricoIncluir')}/>
                  </frameElement>
                  
                } 
                onHide={() => this.fecharModalAtividade('displayHistoricoIncluir')}> 

          <div className="row" style={{display: `${exibieDataHistorico}`}}>
            <div className="col-sm-12">
              <div className="form-group">
              <Checkbox inputId="mudancaData" 
                        name="mudancaData" 
                        value="mudancaData" 
                        onChange={this.onMudancaData} 
                        checked={this.state.mudancaDataHistorico.indexOf('mudancaData') !== -1} />
                &nbsp;
                Mudança de Data
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <InputTextarea id="historico" 
                                type="text" 
                                autoComplete="nope"
                                style={{width: '100%'}} 
                                value={this.state.dsHistorico}
                                onChange={e => this.setState({dsHistorico: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"
                                rows={6} cols={30}/>
              </div>
            </div>
          </div>  
        </Dialog>
        {/**Descrição da Atividade */}
        <Dialog header="Descrição da Atividade"
                style={{ width: '50vw' }} 
                visible={this.state.displayDescricao} 
                footer={
                  <frameElement>
                    <Button label="Salvar" 
                            className="p-button-secondary p-button-text"
                            onClick={() => this.fecharModalAtividade('displayDescricao')}/>
                  </frameElement>
                  
                } 
                onHide={() => this.fecharModalAtividade('displayDescricao')}>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <InputTextarea id="idDescricao" 
                                type="text" 
                                autoComplete="nope"
                                style={{width: '100%'}} 
                                value={this.state.descricao}
                                onChange={e => this.setState({descricao: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"
                                rows={6} cols={30}/>
              </div>
            </div>
          </div>
        </Dialog>
        {/**Pesquisa de Processos */}
        <Dialog header="Busca de Processo"
                visible={this.state.displayProcesso} 
                style={{ width: '60vw' }} 
                footer={this.renderFooterProcesso('displayProcesso')} 
                onHide={() => this.fecharModalAtividade('displayProcesso')}>    

            <DataTable value={this.state.processos}  alwaysShowPaginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                      paginatorRight selectionMode="multiple">
              <Column field="pasta" header="Pasta"></Column>
              <Column field="nrProcesso" header="Processo Original"></Column>
              <Column field="nrCnj" header="Numeração Única"></Column>
              <Column field="autor" header="Autor x Réu" style={{width: '300px'}}></Column>
              <Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
              <Column body={this.acoesProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
            </DataTable>
        </Dialog>

         {/**Arquivos Anexados */}
         <Dialog header="Arquivos Anexados"
                style={{ width: '40vw' }} 
                visible={this.state.displayArquivosAnexados} 
                footer={
                  <frameElement>
                    <Button label="Fechar" 
                            className="p-button-secondary p-button-text"
                            onClick={() => this.fecharModalAtividade('displayArquivosAnexados')}/>
                  </frameElement>
                  
                } 
                onHide={() => this.fecharModalAtividade('displayArquivosAnexados')}>
            
            <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">  
                    <div className="container">
                      
                      <Upload onUpload={this.handleUpload}/>
                      {!!upLoadFiles && (
                        <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                      )}
                    
                    </div>
                  </div>
                </div>
              </div>
              <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                          emptyMessage="Nenhum Arquivo">
                <Column field="arquivo" header="Arquivo"/>
                <Column field="dsArquivo" header="Descrição"/>
                <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
              </DataTable> 
          </Dialog>   
          {/**Adicionar descrição ao arquivo */}
          <Dialog header="Descrição do Arquivo"
                  visible={this.state.modalDescricaoArquivo} 
                  style={{ width: '40vw' }} 
                  footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                  onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="descricaoArquivo">Descrição</label>
                    <InputText id="descricaoArquivo" 
                          type="text" 
                          style={{width: '100%', height: '37px'}} 
                          value={this.state.dsArquivo}
                          onChange={e => this.setState({dsArquivo: e.target.value})}
                          className="p-inputtext-sm p-d-block p-mb-1"/>
                  </div>
                </div>
              </div>
        </Dialog>

        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <TabView activeIndex={this.state.tabAtivo}>
                <TabPanel header="Painel de Atividades">
                  <div className="card card-primary card-outline">
                    <div className="card-header" style={{display: 'inline'}}>
                      <h3 className="card-title">
                        <i className="fa fa-solid fa-network-wired"></i>
                        &nbsp;
                        <span> Meu Painel</span>
                        &nbsp;&nbsp;
                        <a className="cursor" title="Atualizar Painéis" onClick={this.atualizarPaineis}>
                          <i className="pi pi-refresh"></i>
                        </a>
                        &nbsp;
                        &nbsp;
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={this.state.pesquisaAtividade} size="50" 
                                      id="idFiltrar"
                                      onChange={(e) => this.setState({pesquisaAtividade: e.target.value})} 
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      autoComplete="nope"
                                      onKeyPress={event => event.key === 'Enter' && this.consultarPaineis()}
                                      style={{width: '100%', height: '32px'}} 
                                      placeholder="Filtrar Atividades" />
                        </span>
                      </h3>
                      <div style={{display: 'inline', paddingTop: '10px', fontWeight: 'bold', fontSize: '12px', display: `${this.state.exibeOcorrenciasEncontradas}`}}>
                        &nbsp;
                        &nbsp;
                        {this.state.ocorrenciasEncontradas}
                      </div> 
                    </div>
                    <Backdrop
                      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                      open={this.state.openSpinner}>
                      <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                    </Backdrop>

                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <h3 className="card-title">
                            <i className="fa fa-light fa-user-check" />
                            <span> Atribuídas a mim ({this.state.quantidadeTotalResponsavel})</span>
                          </h3>  
                          <br/>
                          <br/>
                          <Accordion multiple>
                            <AccordionTab header={
                              <frameElement>
                                <div>
                                  <div>Atrasadas (<strong>{this.state.quantidadeAtividadesAtrasadas})</strong></div>
                                </div>
                              </frameElement>
                            }>
                              <div className="dataview-demo">
                                <DataView value={this.state.atividadesAtrasadasResponsavelList}
                                          layout={this.state.layout}
                                          emptyMessage=" "
                                          itemTemplate={this.template}/>
                              </div>
                            </AccordionTab>
                            <AccordionTab header={
                              <frameElement>
                                <div>
                                  <div>Hoje (<strong>{this.state.quantidadeAtividadesHoje})</strong></div>
                                </div>
                              </frameElement>
                            }>
                              <div className="dataview-demo">
                                <DataView value={this.state.atividadesHojeResponsavelList}
                                  layout={this.state.layout}
                                  emptyMessage=" "
                                  itemTemplate={this.template}/>
                              </div>
                            </AccordionTab>
                            <AccordionTab header={
                              <frameElement>
                                <div>
                                  <div>Próximo 7 dias (<strong>{this.state.quantidadeAtividadesSete})</strong></div>
                                </div>
                              </frameElement>
                            }>
                              <div className="dataview-demo">
                                <DataView value={this.state.atividadesSeteResponsavelList}
                                  layout={this.state.layout}
                                  emptyMessage=" "
                                  itemTemplate={this.template}/>
                              </div>
                            </AccordionTab>
                            <AccordionTab header={
                              <frameElement>
                                <div>
                                  <div>Próximo 30 dias (<strong>{this.state.quantidadeAtividadesTrinta})</strong></div>
                                </div>
                              </frameElement>
                            }>
                              <div className="dataview-demo">
                                <DataView value={this.state.atividadesTrintaResponsavelList}
                                  layout={this.state.layout}
                                  emptyMessage=" "
                                  itemTemplate={this.template}/>
                              </div>
                            </AccordionTab>
                          </Accordion>
                            <br></br>
                            <br></br>
                              <h5>Atividades Criadas</h5>
                              
                                <Chart type="bar" data={this.state.graficoStatusData}/>
                              
                        </div>
                        <div className="col-md-4">
                          <h3 className="card-title">
                            <i className="fa fa-duotone fa-users"></i>
                              <span> Meus interesses ({this.state.quantidadeTotalInteressados})</span>
                            </h3>  
                          <br/>
                          <br/>
                          <Accordion multiple>
                            <AccordionTab header={
                              <frameElement>
                                <div>
                                  <div>Atrasadas (<strong>{this.state.quantidadeAtrasadosInteressados})</strong></div>
                                </div>
                              </frameElement>
                            }>
                              <DataView value={this.state.atividadesAtrasadasInteressadosList}
                                layout={this.state.layout}
                                emptyMessage=" "
                                itemTemplate={this.template}/>
                            </AccordionTab>
                            <AccordionTab header={
                              <frameElement>
                                <div>
                                  <div>Hoje (<strong>{this.state.quantidadeHojeInteressados})</strong></div>
                                </div>
                              </frameElement>
                            }>
                              <DataView value={this.state.atividadesHojeInteressadosList}
                                layout={this.state.layout}
                                emptyMessage=" "
                                itemTemplate={this.template}/>
                            </AccordionTab>
                            <AccordionTab header={
                              <frameElement>
                                <div>
                                  <div>Próximos 7 dias (<strong>{this.state.quantidadeSeteInteressados})</strong></div>
                                </div>
                              </frameElement>
                            }>
                              <DataView value={this.state.atividadesSeteInteressadosList}
                                layout={this.state.layout}
                                emptyMessage=" "
                                itemTemplate={this.template}/>
                            </AccordionTab>
                            <AccordionTab header={
                              <frameElement>
                                <div>
                                  <div>Próximos 30 dias (<strong>{this.state.quantidadeTrintaInteressados})</strong></div>
                                </div>
                              </frameElement>
                            }>
                              <DataView value={this.state.atividadesTrintaInteressadosList}
                                layout={this.state.layout}
                                emptyMessage=" "
                                itemTemplate={this.template}/>
                            </AccordionTab>
                          </Accordion>        
                            <br></br>
                            <br></br>
                            <h5>Seu dia</h5>
                            <br></br>
                            <GaugeChart id="gauge-chart"
                                        textColor="#333" 
                                        nrOfLevels={4} 
                                        percent={this.state.pontuacao}/>
                                  
                        </div>
                        <div className="col-md-4">
                          <h3 className="card-title">
                            <i className="fa fa-duotone fa-calendar-check"></i>
                              <span> Tarefas com horário ({this.state.quantidadeTotalCompromissos})</span>
                            </h3>  
                            <br/>
                            <br/>
                            <Accordion multiple>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>Atrasadas (<strong>{this.state.quantidadeAtrasadosCompromissos})</strong></div>
                                  </div>
                                </frameElement>
                              }>
                                <DataView value={this.state.compromissosAtrasadosList}
                                  layout={this.state.layout}
                                  emptyMessage=" "
                                  itemTemplate={this.template}/>
                              </AccordionTab>
                              <AccordionTab header={
                                <frameElement>
                                    <div>
                                      <div>Hoje (<strong>{this.state.quantidadeHojeCompromissos})</strong></div>
                                    </div>
                                  </frameElement>
                              }>
                                <DataView value={this.state.compromissosHojeList}
                                  layout={this.state.layout}
                                  emptyMessage=" "
                                  itemTemplate={this.template}/>
                              </AccordionTab>
                              <AccordionTab header={
                                  <frameElement>
                                    <div>
                                      <div>Próximo 7 dias (<strong>{this.state.quantidadeSeteCompromissos})</strong></div>
                                    </div>
                                  </frameElement>
                              }>
                                <DataView value={this.state.compromissosSeteList}
                                  layout={this.state.layout}
                                  emptyMessage=" "
                                  itemTemplate={this.template}/>
                              </AccordionTab>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>Próximo 30 dias (<strong>{this.state.quantidadeTrintaCompromissos})</strong></div>
                                  </div>
                                </frameElement>
                              }>
                                <DataView value={this.state.compromissosTrintaList}
                                  layout={this.state.layout}
                                  emptyMessage=" "
                                  itemTemplate={this.template}/>
                              </AccordionTab>
                            </Accordion>
                            <br></br>
                              <div>
                              <FullCalendar
                                    plugins={[dayGridPlugin, interactionPlugin, timegridPlugin]}
                                    initialView="dayGridMonth"
                                    editable={true}
                                    selectable={true}
                                    locales={[ptBrLocale]}
                                    selectMirror={true}
                                    dayMaxEvents={true}
                                    events={this.state.agenda}
                                    eventClick={this.exibirAtividades}
                                />
                              </div>
                        </div>
                      </div>
                      <br></br>
                      <div textAlign="left" style={{display: `${this.state.exibirAtividades}`}}>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <strong>Data Selecionada: {this.state.dataFiltroAgenda}</strong>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div style={{display: `${this.state.exibirAtividades}`}}>
                        <DataTable value={this.state.atividadesLista}  
                                  alwaysShowPaginator responsiveLayout="scroll"
                                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                  currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" 
                                  rows={10} 
                                  emptyMessage=" "
                                  paginatorRight selectionMode="multiple">
                          <Column field="status.status" header="Status"></Column>
                          <Column body={this.acoesAtividadeConsultaCalendario} exportable={false} style={{ minWidth: '8rem' }}header="Atividade"></Column>
                          <Column field="fase.nome" header="Fase"></Column>
                          <Column field="subGrupo.nome" header="Sub-Grupo"></Column>
                          <Column field="grupoPai" header="Grupo"></Column>
                          <Column field="dtLimite" header="Data Limite"></Column>
                          <Column field="dtFatal" header="Prazo Fatal"></Column>
                          <Column body={this.acoesAtividadeConsultaCalendarioProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Processo"></Column>
                          <Column field="processo.autor" header="Ator(es)"></Column>
                          <Column field="processo.reu" header="Réu(s)"></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
                  </TabPanel>
                    <TabPanel header="Painel Kanban" onTa>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <MultiSelect inputId="idGrupos" 
                                        value={this.state.selectGruposKanban}
                                        options={this.state.gruposKanban} 
                                        style={{width: '100%', height: '32px'}}
                                        onChange={(e) => this.setState({ selectGruposKanban: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                            <MultiSelect inputId="idGrupos" 
                                        value={this.state.selectUsuariosKanban}
                                        options={this.state.usuariosKanban} 
                                        style={{width: '100%', height: '32px'}} 
                                        onChange={(e) => this.setState({ selectUsuariosKanban: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dataKanbanInicial} 
                                      onChange={(e) => this.setState({ dataKanbanInicial: e.value })} 
                                      locale="es"
                                      style={{width: '45%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Data Inicial"
                                      mask="99/99/9999"/>
                            &nbsp;
                            <Calendar id="mask" 
                                      value={this.state.dataKanbanFinal} 
                                      onChange={(e) => this.setState({ dataKanbanFinal: e.value })} 
                                      locale="es"
                                      style={{width: '45%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Data Final"
                                      mask="99/99/9999"/>
                          </div>
                        </div>    
                        <div className="col-sm-1">
                          <div className="form-group">
                            <Button style={{height: '32px'}} type="button" className="p-button-secondary p-button-text p-button-sm" 
                                onClick={this.consultarKanban}>
                            <i className="pi pi-filter"></i> &nbsp;&nbsp;Filtrar</Button>
                          </div>
                        </div>
                      </div>
              
                      <div style={{display: 'inline', paddingTop: '10px', fontWeight: 'bold', fontSize: '12px', display: `${this.state.exibeOcorrenciasEncontradas}`}}>
                        &nbsp;
                        &nbsp;
                        {this.state.ocorrenciasEncontradas}
                      </div> 
                      
                      <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={this.state.openSpinner}>
                        <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                      </Backdrop>
                      <br></br>
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <Accordion activeIndex={0}>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>{this.state.kanbanAtivoLabel} - ({this.state.totalAtivos})</div>
                                  </div>
                                </frameElement>
                              }>
                                <div className="dataview-demo">
                                  <DataView value={this.state.kanbanAtivo}
                                    layout={this.state.layout}
                                    emptyMessage=" "
                                    itemTemplate={this.templateKanban}/>
                                </div>
                              </AccordionTab>
                            </Accordion>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <Accordion activeIndex={0}>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>{this.state.kanbanFazendoLabel} - ({this.state.totalFazendo})</div>
                                  </div>
                                </frameElement>
                              }>
                                <div className="dataview-demo">
                                  <DataView value={this.state.kanbanFazendo}
                                    layout={this.state.layout}
                                    emptyMessage=" "
                                    itemTemplate={this.templateKanban}/>
                                </div>
                              </AccordionTab>
                            </Accordion>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <Accordion activeIndex={0}>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>{this.state.kanbanAguardandoLabel} - ({this.state.totalAguardando})</div>
                                  </div>
                                </frameElement>
                              }>
                                <div className="dataview-demo">
                                  <DataView value={this.state.kanbanAguardando}
                                    layout={this.state.layout}
                                    emptyMessage=" "
                                    itemTemplate={this.templateKanban}/>
                                </div>
                              </AccordionTab>
                            </Accordion>
                         </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <Accordion activeIndex={0}>
                              <AccordionTab header={
                                <frameElement>
                                  <div>
                                    <div>{this.state.kanbanConcluidoLabel}</div>
                                  </div>
                                </frameElement>
                              }>
                                <div className="dataview-demo">
                                  <DataView value={this.state.kanbanConcluido}
                                    layout={this.state.layout}
                                    emptyMessage=" "
                                    itemTemplate={this.templateKanban}/>
                                </div>
                              </AccordionTab>
                            </Accordion>
                          </div>
                        </div>
                      </div>
                  </TabPanel>
                </TabView>
             </section>
          </div>
        </div>
      </>
    )
  }
}

Home.contextType = AuthContext;

export default withRouter(Home)
